"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionLowRateChargingTelemetryValidation = void 0;
class ChargingTransactionLowRateChargingTelemetryValidation {
    static isValid(entity) {
        // Validate entity.powerKW for existence and correct type.
        if (entity.powerKW == undefined)
            return false;
        if (typeof entity.powerKW !== "number")
            return false;
        // Validate entity.powerLimitKW for existence and correct type.
        if (entity.powerLimitKW == undefined)
            return false;
        if (typeof entity.powerLimitKW !== "number")
            return false;
        // Validate entity.evMaxPower for existence and correct type.
        if (entity.evMaxPower == undefined)
            return false;
        if (typeof entity.evMaxPower !== "number")
            return false;
        // Validate entity.voltage for existence and correct type.
        if (entity.voltage == undefined)
            return false;
        if (typeof entity.voltage !== "number")
            return false;
        // Validate entity.evMaxVoltage for existence and correct type.
        if (entity.evMaxVoltage == undefined)
            return false;
        if (typeof entity.evMaxVoltage !== "number")
            return false;
        // Validate entity.evseMaxVoltage for existence and correct type.
        if (entity.evseMaxVoltage == undefined)
            return false;
        if (typeof entity.evseMaxVoltage !== "number")
            return false;
        // Validate entity.evTargetVoltage for existence and correct type.
        if (entity.evTargetVoltage == undefined)
            return false;
        if (typeof entity.evTargetVoltage !== "number")
            return false;
        // Validate entity.current for existence and correct type.
        if (entity.current == undefined)
            return false;
        if (typeof entity.current !== "number")
            return false;
        // Validate entity.evMaxCurrent for existence and correct type.
        if (entity.evMaxCurrent == undefined)
            return false;
        if (typeof entity.evMaxCurrent !== "number")
            return false;
        // Validate entity.evseMaxCurrent for existence and correct type.
        if (entity.evseMaxCurrent == undefined)
            return false;
        if (typeof entity.evseMaxCurrent !== "number")
            return false;
        // Validate entity.evTargetCurrent for existence and correct type.
        if (entity.evTargetCurrent == undefined)
            return false;
        if (typeof entity.evTargetCurrent !== "number")
            return false;
        // Validate entity.SoC for existence and correct type.
        if (entity.SoC == undefined)
            return false;
        if (typeof entity.SoC !== "number")
            return false;
        // If entity.timeToBulkSoc exists, validate that it has the correct type.
        if (entity.timeToBulkSoc != undefined) {
            if (typeof entity.timeToBulkSoc !== "number")
                return false;
        }
        // If entity.timeToFullSoc exists, validate that it has the correct type.
        if (entity.timeToFullSoc != undefined) {
            if (typeof entity.timeToFullSoc !== "number")
                return false;
        }
        // If entity.detailTime exists, validate that it has the correct type.
        if (entity.detailTime != undefined) {
            if (!(entity.detailTime instanceof Date))
                return false;
        }
        return true;
    }
}
exports.ChargingTransactionLowRateChargingTelemetryValidation = ChargingTransactionLowRateChargingTelemetryValidation;
